



































import { Component, Vue } from "vue-property-decorator"
import { Wormhole, PortalTarget } from "portal-vue"

import Page from "@/components/New/Page/Page.vue"

export enum CasesPortalNames {
	FooterLeft = "cases-footer-left",
	FooterRight = "cases-footer-right",
	HeaderTitle = "cases-header-title",
	HeaderContent = "cases-header-content",
	SubHeader = "cases-subheader"
}
@Component({
	components: {
		"page": Page,
		"portal-target": PortalTarget
	}
})
export default class Cases extends Vue {
	casesPortalNames = CasesPortalNames;

	private get hasSubHeaderFooterContent () {
		return Wormhole.hasContentFor(CasesPortalNames.SubHeader)
	}

	private get hasLeftFooterContent () {
		return Wormhole.hasContentFor(CasesPortalNames.FooterLeft)
	}

	private get hasRightFooterContent () {
		return Wormhole.hasContentFor(CasesPortalNames.FooterRight)
	}

	private get hasHeaderContent () {
		return Wormhole.hasContentFor(CasesPortalNames.HeaderContent)
	}
}
